import dayjs from 'dayjs';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
};
const initialAuthState = {
  authToken: undefined,
  refreshToken: undefined,
  expiresIn: undefined,
};
export const reducer = persistReducer(
  { storage, key: 'v726-demo1-auth', whitelist: ['authToken', 'refreshToken', 'expiresIn'] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { access_token, refresh_token, expires_in } = action.payload;
        const now = dayjs().unix(); // seconds
        const expiresIn = now + expires_in;
        return {
          ...state,
          authToken: access_token,
          refreshToken: refresh_token,
          expiresIn,
        };
      }
      case actionTypes.Logout: {
        return initialAuthState;
      }

      default:
        return state;
    }
  }
);
export const actions = {
  login: (payload) => ({ type: actionTypes.Login, payload }),
  logout: () => ({ type: actionTypes.Logout }),
};
